/* GraphQL */ `
  fragment GetGlycerinArticleIdFragment on Product {
    orderNumber
    promotion
  }
`;

export type GetGlycerinArticleIdProps = {
  orderNumber: string;
  promotion: string | null;
};

export const getGlycerinArticleId = (data: GetGlycerinArticleIdProps) => {
  const { orderNumber, promotion } = data;

  return { articleId: `${orderNumber}${promotion}` };
};
